(function () {
  $(document).ready(function () {
    // $(".essential-hero-slider").slick({
    //   slidesToShow: 1,
    //   dots: true,
    // });

    class Countdown {
        constructor() {
            this.setCountdown();
        }

        setCountdown() {
            const targetTime = new Date();
            targetTime.setHours(targetTime.getHours() + 6);
            targetTime.setMinutes(targetTime.getMinutes() + 30);
            targetTime.setSeconds(0);
            this.targetCountdown = targetTime.getTime();

            const x = setInterval(() => {
                const now = new Date().getTime();
                const distance = this.targetCountdown - now;

                let hours = Math.floor(distance / (1000 * 60 * 60));
                let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((distance % (1000 * 60)) / 1000);
                $(".countdown .hour").text(hours.toString().padStart(2, '0'));
                $(".countdown .min").text(minutes.toString().padStart(2, '0'));
                $(".countdown .sec").text(seconds.toString().padStart(2, '0'));

                if (distance < 0) {
                    clearInterval(x);
                    $(".countdown .hour").text("00");
                    $(".countdown .min").text("00");
                    $(".countdown .sec").text("00");
                    this.setCountdown();
                }
            }, 1000);
        }
    }
    const targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + 1)

    const count = new Countdown(targetDate);
  });



  // Toggle debugging logs
window.debugMode = false;
function logger(message) {
  if (window.debugMode) {
    console.log("NP", message);
  }
}

window.lpRechargeAttr = {
  subscriptionChecked: false,
  subscriptionFrequency: 1,
  activePack: 3,
};

// form
const setupForm = () => {
  const changeRegPrice = $(".strikethrough-lg");
  const changeTextSave = $(".text-save");
  const changePercentOffPrice = $(".off-price");
  const changeSalePrice = $(".sale-price");
  const changePieces = $(".v-packs-option");
  const subscriptionSalePrice = $(".subscribe-option .sale-price");

  const currentVariantId = document.querySelector(
    'input[name="packs_variant_id"]'
  );
  const currentPrice = document.querySelector('input[name="packs_price"]');

  const updateFrequencyFromEl = (triggerEl) => {
    const matches = triggerEl.find("option:selected").text().match(/\d+/);
    logger(["updateFrequencyFromEl", triggerEl, matches]);

    // update selected frequency
    $(".recharge-frequency").val(triggerEl.val());

    var vFrequency = -1;
    if (matches && matches.length > 0) {
      vFrequency = parseInt(matches[0]);
      window.lpRechargeAttr.subscriptionFrequency = vFrequency;
    }
  };

  const updateUseCase = () => {
    const vPacks = window.lpRechargeAttr.activePack;
    const vFrequency = window.lpRechargeAttr.subscriptionFrequency;
    logger(["updateUseCase", vPacks, vFrequency]);

    var vFamilyUseText = "Perfect for everyday usage families with 2 children";
    if (vPacks == 2 || vPacks == 3) {
      if (vFrequency == 1) {
        vFamilyUseText = "Perfect for everyday usage families with 2 children";
      } else if (vFrequency == 2) {
        vFamilyUseText = "Perfect for everyday use by families with one child";
      } else if (vFrequency == 3) {
        vFamilyUseText =
          "Perfect for use a few times a week by families with one child";
      }
    } else if (vPacks == 4) {
      if (vFrequency == 1) {
        vFamilyUseText =
          "Perfect for everyday use by families with three children";
      } else if (vFrequency == 2) {
        vFamilyUseText =
          "Perfect for everyday use by families with two or three children";
      } else if (vFrequency == 3) {
        vFamilyUseText = "Perfect for everyday use by families with one child";
      }
    }

    $(".family-use").text(vFamilyUseText);
  };

  const switchSubscriptionPricing = () => {
    logger("switchSubscriptionPricing");
    const listPacks = document.querySelectorAll(".list-packs");

    let priceAttr = "data-price";
    // if (window.lpRechargeAttr.subscriptionChecked) {
    //   priceAttr = "data-subscription-price";
    // }

    listPacks.forEach((listPack) => {
      const pack = listPack.getAttribute("data-pack");
      const packPrice = listPack.querySelector(".pack-price");
      const regPrice = listPack.querySelector(`.reg-price-${pack}`);
      const savePrice = listPack.querySelector(`.save-price-${pack}`);
      const savePercent = listPack.querySelector(`.save-percent-${pack}`);

      packPrice.innerText = packPrice.getAttribute(priceAttr);
      regPrice.innerText = regPrice.getAttribute(priceAttr);
      savePrice.innerText = savePrice.getAttribute(priceAttr);
      savePercent.innerText = savePercent.getAttribute(priceAttr);
    });
  };

  const updateActivePrices = () => {
    const pack = window.lpRechargeAttr.activePack;
    logger(["updateActivePrices", pack]);

    $(".list-packs").removeClass("active-slide");

    if (pack == 1) {
      $(".np-multiple-pack").hide();
      $(".np-one-pack").show();
    } else {
      $(".np-multiple-pack").show();
      $(".np-one-pack").hide();
    }

    const listPacks = document.querySelectorAll(
      `.list-packs[data-pack="${pack}"]`
    );

    let priceAttr = "data-price";
    if (window.lpRechargeAttr.subscriptionChecked) {
      priceAttr = "data-subscription-price";
    }

    listPacks.forEach((listPack) => {
      changeRegPrice.html(
        listPack.querySelector(`.reg-price-${pack}`).getAttribute(priceAttr)
      );
      changePercentOffPrice.html(
        listPack.querySelector(`.save-percent-${pack}`).getAttribute(priceAttr)
      );
      changeSalePrice.html(
        listPack.querySelector(`.save-price-${pack}`).getAttribute(priceAttr)
      );
      changeTextSave.html(
        listPack.querySelector(`.text-save-${pack}`).getAttribute(priceAttr)
      );
      changePieces.html(listPack.querySelector(`.pcs-${pack}`).innerHTML);
      subscriptionSalePrice.html(
        listPack
          .querySelector(`.save-price-${pack}`)
          .getAttribute("data-subscription-price")
      );

      currentVariantId.value = listPack.getAttribute("data-id");
      listPack.classList.add("active-slide");
    });
  };

  // default
  updateActivePrices();
  updateUseCase();

  // change active pack
  $(".list-packs").on("click", function (e) {
    logger("list-packs click");
    e.preventDefault();
    e.stopPropagation();
    window.lpRechargeAttr.activePack = $(this).attr("data-pack");

    // if data-pack is 1
    if (window.lpRechargeAttr.activePack == 1) {
      logger("list-packs[data-pack='1'] click");
      $(".np-multiple-pack").hide();
      $(".recharge-subscribe-label").prop("checked", false);
      $(".recharge-frequency").val($(".recharge-frequency option:first").val());
      $(".subscribe-frequency").hide();
      $(".np-one-pack").show();
    } else {
      if (window.lpRechargeAttr.subscriptionChecked == true) {
        $(".subscribe-frequency").show();
        $(".np-multiple-pack").show();
      }
    }

    updateActivePrices();
  });

  // add to cart
  $(".button-proceed").on("click", function (e) {
    logger("button-proceed click");
    e.preventDefault();
    e.stopPropagation();

    let rechargeFrequency = -1;
    if ($("#rechargeSubscribe").is(":checked")) {
      rechargeFrequency = $(".recharge-frequency").val();
    }
    
    addItemToCart(currentVariantId.value, 1, rechargeFrequency);
    console.log('after additemtocart');
    return false;
  });

  const productHandle = window.product.handle;
  $.getJSON(
    `${window.Shopify.routes.root}products/${productHandle}.js`,
    (product) => {
      if (product.selling_plan_groups.length !== 1) {
        logger("Recharge does not have exactly 1 selling plan group, hiding");
        $(".recharge-container").hide();
        return;
      }
      logger(
        "recharge - selling plans",
        product.selling_plan_groups[0].selling_plans
      );

      const sellingPlans = product.selling_plan_groups[0].selling_plans;
      sellingPlans.forEach((plan) => {
        const option = document.createElement("option");
        option.value = plan.id;
        option.text = plan.name.replace("Delivery e", "E");
        $(".recharge-frequency").append(option);
      });
    }
  );

  // based on
  // https://support.rechargepayments.com/hc/en-us/articles/360008683774-Adding-an-item-to-the-cart-with-AJAX
  function addItemToCart(variant_id, qty, selling_plan) {
    logger(["addItemToCart", variant_id, qty, selling_plan]);
    data = {
      id: variant_id,
      quantity: qty,
    };
    if (selling_plan > 0) {
      data["selling_plan"] = selling_plan;
    }
    logger(["data", data]);

    const product = window.product;

    // fbq_data = {
    //   content_name: product.title,
    //   content_ids: product.id,
    //   content_type: "product_group",
    //   value: currentPrice.value,
    //   currency: product.currency,
    // };
    // logger(["fbq_data", fbq_data]);
    // fbq("track", "AddToCart", fbq_data);
    // fbq("track", "InitiateCheckout", fbq_data);

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        // have to timeout to outsmart iCart opening
        setTimeout(function () {
          window.location.href = "/checkout";
        }, 1000);
        return false;
      },
    });
  }

  $(".recharge-container a").click(function (e) {
    logger("recharge-container a click");
    e.preventDefault();
  });

  $(".recharge-subscribe-label").click(function (e) {
    logger("recharge-subscribe-label click");
    e.preventDefault();
    e.stopPropagation();
    const rechargeCheckbox = $(".recharge-subscribe");
    const subscribeFrequency = $(".subscribe-frequency");

    if ($(this).siblings(".recharge-subscribe").is(":checked")) {
      window.lpRechargeAttr.subscriptionChecked = false;
      subscribeFrequency.hide();
      rechargeCheckbox.prop("checked", false);
    } else {
      window.lpRechargeAttr.subscriptionChecked = true;
      rechargeCheckbox.prop("checked", true);
      subscribeFrequency.show();
    }

    switchSubscriptionPricing();
    updateActivePrices();
  });

  const rechargeFrequencies = document.querySelectorAll(".recharge-frequency");

  rechargeFrequencies.forEach((rechargeFrequency) => {
    rechargeFrequency.addEventListener("change", () => {
      updateFrequencyFromEl($(rechargeFrequency));
      updateUseCase();
    });
  });
};

 

// slider
const setupSlider = () => {
  const openBtns = document.querySelectorAll(".primary-btn, .card-aroma-btn");
  const closeBtn = document.querySelector(".close-btn");
  const disableSidebar = document.querySelector(".sidebar");
  const sidebar = document.querySelector(".sidebar");
  const cons = document.querySelector("#cons");
  const addBodyClass = document.querySelector("body");

  const closeFunction = () => {
    logger("closeFunction");
    cons.style.transform = "translateX(700px)";
    setTimeout(() => {
      sidebar.classList.remove("active-sidebar");
      sidebar.style.width = "0%";
      sidebar.style.position = "absolute";
      addBodyClass.style.overflowY = "visible";
      addBodyClass.classList.remove("slide");
    }, 300);
  };

  disableSidebar.addEventListener("click", (e) => {
    logger("disableSidebar click");
    let xPosition = e.clientX;
    const widthOfSectionSideBar = disableSidebar.clientWidth;
    const widthOfSidebar = cons.offsetWidth;
    if (
      xPosition < widthOfSectionSideBar - widthOfSidebar &&
      sidebar.classList.contains("active-sidebar")
    ) {
      closeFunction();
    }
  });

  openBtns.forEach((openBtn) => {
    openBtn.addEventListener("click", (e) => {
      logger("openBtn click");
      e.preventDefault();
      sidebar.classList.add("active-sidebar");
      sidebar.style.width = "100%";
      sidebar.style.position = "fixed";
      cons.style.transform = "translateX(0px)";
      addBodyClass.classList.add("slide");
    });
  });

  closeBtn.addEventListener("click", () => {
    logger("closeBtn click");
    closeFunction();
  });
};

// scrolling
const setupScrollActions = () => {
  $("#to-top").click(function () {
    logger("to-top click");
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      500
    );
  });
  $(window).scroll(function () {
    // logger("window scroll");
    var t = $(window).scrollTop();
    t >= 501 && $(".navbar").addClass("fixed-top"),
      t <= 500 && $(".navbar").removeClass("fixed-top");
  }); 
};

$(document).ready(function () {
    $(".shopify-section-group-header-group").remove();
  $("body").addClass("sleepypatch-template");
  $('[data-toggle="np-tooltip"]').tooltip();

  setupScrollActions();
  setupForm();
  setupSlider();
 
  $('.subscribe-frequency .itool-skip').click(function(){
     event.preventDefault(); 
  });
});



})();
